import Page from "~/components/Page";
import { SearchX } from "lucide-react";

const PageNotFound = () => {
  return (
    <Page title="404. Not found">
      <div className="mx-auto flex h-full max-w-3xl flex-col items-center justify-center px-4 py-16 text-center">
        <SearchX className="mb-12 size-40 text-wfp-blue" style={{ transform: "rotate(10deg)" }} />
        <h1 className="mb-4 text-2xl font-semibold">404. Page not found</h1>
        <p className="max-w-[500px]">
          Uh oh, we can't seem to find the page you're looking for. Try going back to the previous page or contact{" "}
          <a href="mailto:IT.ServiceDesk@wfp.org" className="text-primary-600 hover:underline">
            IT.ServiceDesk@wfp.org
          </a>{" "}
          if you think there is a problem.
        </p>
      </div>
    </Page>
  );
};

export default PageNotFound;
